import React from "react";
import { FaTrash, FaCheck, FaTimes } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { getDateFormat } from "../../../../../helpers/Utils";
import { DatePicker, Tooltip } from "antd";
import moment from "moment";
import { AiOutlineStar } from "react-icons/ai";
import Axios from "axios";

function SupplyingTable({
  disabled,
  item,
  deleteSupply,
  updateSupplying,
  id_order_row,
  product_reference,
  mode,
  orderId,
}) {
  const [showRemove, setShowRemove] = React.useState(false);
  const [editSupplying, setEditSupplying] = React.useState(false);
  const [newDateSupplying, setNewDateSupplying] = React.useState(item.date);
  const [disabledDates, setDisabledDates] = React.useState([]);

  React.useEffect(() => {
    const fetchDisabledDates = async () => {
      try {
        const { data } = await Axios.get("/api/v1/calendars");
        setDisabledDates(data.map((date) => moment(date, "YYYY-MM-DD")));
      } catch (err) {
        console.error("Error fetching disabled dates: ", err);
      }
    };
    fetchDisabledDates();
  }, []);
  const renderCode = () => {
    if (item.product_code) {
      return <span className="text-danger">{item.product_code}</span>;
    } else if (product_reference) {
      return <span>{product_reference}</span>;
    } else if (id_order_row) {
      return <span>{id_order_row}</span>;
    }
  };

  const classname = "residuesItem align-middle";
  if (mode === "Servisas") {
    return (
      <tr
        onMouseEnter={() => setShowRemove(true)}
        onMouseLeave={() => setShowRemove(false)}
      >
        <td className={classname} colSpan="2">
          {item.date || " No date"}
        </td>
        <td className={classname}>{"Repairing: "}</td>
        <td className={classname} colSpan="2">
          {item.supplier?.name} {item.product_code && `(${item.product_code})`}
        </td>
        <td className={classname}>{item.amount == null ? 0 : item.amount}</td>
        <td className={classname} colSpan="2">
          {item.user_title}
        </td>
        <td className={classname}>
          {orderId && (
            <FaTrash
              style={{
                color: "orange",
                cursor: "pointer",
                float: "right",
                visibility: showRemove ? "visible" : "hidden",
              }}
              onClick={() => deleteSupply(item.id, id_order_row)}
            />
          )}
        </td>
      </tr>
    );
  }

  return (
    <>
      {/* <tr>
        <td
          style={{ maxHeight: "15px", height: "15px", verticalAlign: "bottom" }}
          colSpan={4}
        >
          <p
            style={{
              marginTop: 0,
              marginBottom: 0,
              fontSize: 10,
              lineHeight: "12px",
              color: "#212529",
              fontWeight: "500",
            }}
          >
            Shipping to customer
          </p>
        </td>
        <td
          style={{ maxHeight: "15px", height: "15px", fontSize: "1px" }}
          colSpan={2}
        >
          &nbsp;
        </td>
        <td
          style={{ maxHeight: "15px", height: "15px", fontSize: "1px" }}
          colSpan={2}
        >
          &nbsp;
        </td>
        <td
          style={{ maxHeight: "15px", height: "15px", fontSize: "1px" }}
          colSpan={2}
        >
          &nbsp;
        </td>
      </tr> */}
      <div style={{ height: "2px", backgroundColor: "#fbfbfb" }} />
      {item?.supplying_incomes?.map((income, index) => (
        <tr
          style={{
            borderLeft: `1px solid ${item.used_at ? "#03b0f7" : "transprent"}`,
          }}
        >
          <td
            className={editSupplying ? classname : "residuesItem"}
            colSpan="2"
          >
            <p
              style={{
                marginTop: 0,
                marginBottom: 0,
                fontSize: 10,
                lineHeight: "12px",
                color: "#212529",
                fontWeight: "500",
                whiteSpace: "nowrap",
              }}
            >
              Arriving to location
            </p>
            {editSupplying === true ? (
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Data"
                disabledDate={(d) =>
                  !d ||
                  d.isBefore(moment().format("YYYY-MM-DD")) ||
                  disabledDates.some((disabledDate) =>
                    d.isSame(disabledDate, "day")
                  )
                }
                value={getDateFormat(income?.arriving_at)}
                onChange={(_, arg) => setNewDateSupplying(arg)}
              />
            ) : (
              income?.arriving_at || "No date"
            )}
          </td>
          <td className={classname}>
            <div>
              <p
                style={{
                  marginTop: 0,
                  marginBottom: 0,
                  fontSize: 10,
                  lineHeight: "12px",
                  color: "#212529",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                }}
              >
                {product_reference}
              </p>
              {income?.warehouse}
            </div>
          </td>
          <td style={{ whiteSpace: "nowrap" }} className={classname}>
            <p
              style={{
                marginTop: 0,
                marginBottom: 0,
                fontSize: 10,
                lineHeight: "12px",
                color: "#212529",
                fontWeight: "500",
                whiteSpace: "nowrap",
              }}
            >
              &nbsp;
            </p>
            {income?.supplier}
          </td>
          <td className={classname}>&nbsp;</td>
          <td className={classname}>&nbsp;</td>
          <td className={classname}>&nbsp;</td>
          <td className={classname}>&nbsp;</td>
          <td className={classname}>&nbsp;</td>
          <td className={classname}>&nbsp;</td>
        </tr>
      ))}

      <div style={{ height: "2px", backgroundColor: "#fbfbfb" }} />
      <tr
        style={{
          borderLeft: `1px solid ${item.used_at ? "#03b0f7" : "transprent"}`,
        }}
        onMouseEnter={() => setShowRemove(true)}
        onMouseLeave={() => setShowRemove(false)}
      >
        <td className={editSupplying ? classname : "residuesItem"} colSpan="2">
          <p
            style={{
              marginTop: 0,
              marginBottom: 0,
              fontSize: 10,
              lineHeight: "12px",
              color: "#212529",
              fontWeight: "500",
              whiteSpace: "nowrap",
            }}
          >
            Shipping to customer
          </p>
          {editSupplying === true ? (
            <DatePicker
              style={{ width: "100%" }}
              placeholder="Data"
              disabledDate={(d) =>
                !d ||
                d.isBefore(moment().format("YYYY-MM-DD")) ||
                disabledDates.some((disabledDate) =>
                  d.isSame(disabledDate, "day")
                )
              }
              value={getDateFormat(newDateSupplying)}
              onChange={(_, arg) => setNewDateSupplying(arg)}
            />
          ) : (
            item.date || "No date"
          )}
        </td>
        <td className={classname}>
          {item.spec_order && (
            <Tooltip
              className="text-primary mr-1 text-xl"
              placement="top"
              title={"SPEC order"}
            >
              *
            </Tooltip>
          )}
          {renderCode()}
        </td>
        <td className={classname} colSpan="3">
          <div className="d-flex align-items-center">
            {item.guaranteed_delivery && (
              <Tooltip placement="top" title={"Guaranteed delivery"}>
                <AiOutlineStar className="text-orange text-xs mr-2" />
              </Tooltip>
            )}{" "}
            {item.supplier?.name}{" "}
            {item.supplier_code && `(${item.supplier_code})`}{" "}
          </div>
        </td>
        <td className={classname}>*{item.amount == null ? 0 : item.amount}</td>
        <td className={classname} colSpan="2">
          <Tooltip
            placement="top"
            title={moment(item.created_at).format("YYYY-MM-DD HH:mm")}
          >
            {item.user_title}
          </Tooltip>
        </td>
        <td className={classname}>
          {orderId && !disabled && (
            <>
              {editSupplying ? (
                <>
                  <FaCheck
                    style={{
                      color: "green",
                      cursor: "pointer",
                      marginLeft: "5px",
                    }}
                    onClick={() =>
                      updateSupplying(
                        item.id,
                        id_order_row,
                        newDateSupplying
                      ).then((res) => {
                        if (res) {
                          setEditSupplying(false);
                        }
                      })
                    }
                  />
                  <FaTimes
                    style={{
                      color: "red",
                      cursor: "pointer",
                      marginLeft: "5px",
                    }}
                    onClick={() => setEditSupplying(false)}
                  />
                </>
              ) : item.used_at ? (
                <div className="text-primary">USED</div>
              ) : (
                <>
                  <MdEdit
                    style={{
                      color: "red",
                      cursor: "pointer",
                      marginLeft: "5px",
                      visibility: showRemove ? "visible" : "hidden",
                    }}
                    onClick={() => {
                      setNewDateSupplying(item.date);
                      setEditSupplying(true);
                    }}
                  />
                  <FaTrash
                    style={{
                      color: "orange",
                      cursor: "pointer",
                      marginLeft: "5px",
                      visibility: showRemove ? "visible" : "hidden",
                    }}
                    onClick={() => deleteSupply(item.id, id_order_row)}
                  />
                </>
              )}
            </>
          )}
        </td>
      </tr>
    </>
  );
}

export default SupplyingTable;
